import React from "react";
import { CalendarEventType } from "../../../types/calendar";
import { useCalendarEvent } from "../../../context/CalendarEventContext";

// CalendarEventContext is still JS; this is the shape CalendarView relies on.
export interface CalendarEventContextValue {
  selectedEvent: CalendarEventType | null;
  setSelectedEvent: (event: CalendarEventType | null) => void;
  selectedAction: string;
  setSelectedAction: (action: string) => void;
  events: CalendarEventType[];
  setEvents: React.Dispatch<React.SetStateAction<CalendarEventType[]>>;
  fetchedMonths: Set<string>;
  setFetchedMonths: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export const useTypedCalendarEvent = (): CalendarEventContextValue =>
  useCalendarEvent() as CalendarEventContextValue;

// The SalonContext fields CalendarView reads (SalonContext is still JS).
export interface CalendarBusinessInfo {
  id: string;
  salon_name: string;
  timezone: string;
  status: string;
  free_trial_end_date?: string;
}
